// Client-safe constants shared by the server and client entry points. Kept out of
// experiment.utils.tsx, which imports server-only datadog code and so cannot be
// pulled into a "use client" bundle.

// Mirrors the monolith's Eppo::ClientWrapper::FALLBACK_VARIATION. A flag the API
// could not resolve carries this variation; it matches no <Variant name>, so the
// caller renders the default (control) variant.
export const FALLBACK_VARIATION = "no-variation-returned";

// Client-written cookie holding resolved assignments as `id:variant` pairs, so a
// server render under a layout-mounted provider can read the assignment after a
// soft navigation (when the layout, and thus the provider, did not re-run).
export const EXPERIMENT_ASSIGNMENTS_COOKIE = "experiment_assignments";

// Set by each app's locale proxy on a translated page's render, to its locale
// prefix. Eppo never sees the locale, so see localised-experiments.ts.
export const TRANSLATED_LOCALE_HEADER = "x-translated-locale";
